// extracted by mini-css-extract-plugin
module.exports = {"tabs":"TokensTabsPage_tabs__1HpAf"};